// extracted by mini-css-extract-plugin
module.exports = {"text":"text_button-module--text--1a1cU","content":"text_button-module--content--EqqPx"};